import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  Box,
  Typography,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PathwaysIcon from "@mui/icons-material/Forest";
import IntermixIcon from "@mui/icons-material/HomeWork";
import RiskIcon from "@mui/icons-material/Whatshot";
import { Link } from "react-router-dom";
import usePage from "hooks/usePage";

export const sideNavWidth = 70;

const NavIcon = ({ Icon, children, selected, to }) => {
  return (
    <ListItem disablePadding sx={{ margin: "4px 0" }}>
      <ListItemButton
        component={Link}
        to={to}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          height: "60px",
          flex: "0 0 60px",
          margin: "0 auto",
          gap: "4px",
          textAlign: "center",
          backgroundColor: selected ? "bg.secondary" : "",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "24px",
            height: "24px",
            backgroundColor: "bg.main",
          }}
        >
          <Icon sx={{ color: "white.main" }} />
        </Box>
        <Typography sx={{ fontSize: "12px" }} color="text.primary">
          {children}
        </Typography>
      </ListItemButton>
    </ListItem>
  );
};

export default function SideNav() {
  const { page, projectId, isSharePage } = usePage();
  const prefix = isSharePage ? "/viewer" : "";
  const vegLink = `${prefix}/project/${projectId}/vegetation`;
  const urbanLink = `${prefix}/project/${projectId}/urban`;
  const riskLink = `${prefix}/project/${projectId}/risk`;

  return (
    <Drawer
      sx={{
        width: sideNavWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: sideNavWidth,
          display: "flex",
          padding: "80px 0",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <List>
        {!isSharePage && (
          <NavIcon Icon={HomeIcon} to="/" selected={page === "home"}>
            Home
          </NavIcon>
        )}
        <NavIcon
          Icon={PathwaysIcon}
          to={vegLink}
          selected={page === "vegetation"}
        >
          Veg
        </NavIcon>
        <NavIcon Icon={IntermixIcon} to={urbanLink} selected={page === "urban"}>
          Urban
        </NavIcon>
        {!isSharePage && (
          <NavIcon Icon={RiskIcon} to={riskLink} selected={page === "risk"}>
            Risk
          </NavIcon>
        )}
      </List>
    </Drawer>
  );
}
